import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { cpf } from 'cpf-cnpj-validator';
import * as moment from "moment";
import { API, BACKGROUNDIMAGE, USA_BETO, USA_CARRO, USA_LAMINAS, USA_PACOTE, USA_TERMOMETRO } from "src/app/app.config";
import { Aereo, Busca, Carro, Hotel, Orcamento, Pacote, Reserva, ReservaPagamento, Servico } from "src/app/model";
import { ProdutoOffline } from "src/app/model/gerenciamento/produtooffline.model";
import { BetoCarrero } from "src/app/model/turismo/beto-carrero.model";
import { Circuito } from "src/app/model/turismo/circuito.model";
import { LoginService, ReservaService, Util, VoucherService, CircuitoService } from "src/app/services";
import { CarroService } from "src/app/services/turismo/carro.service";
import { ProdutoOfflineService } from "src/app/services/turismo/produtooffline.service";
import { AgenciaService } from "./../../services/cadastro/agencia.service";
import { UsuarioService } from "./../../services/usuario.service";
import { addOrSubtractDays } from "src/app/utils/luxon.helper";

@Component({
    selector: "app-orcamento",
    templateUrl: "./orcamento.component.html",
    styleUrls: [
        "./orcamento.component.scss",
        "../../../assets/styles/layoutPattern.scss",
    ],
    standalone: false
})
export class OrcamentoComponent implements OnInit {
    @Input() servicos: Servico;
    @Input() Orcamento: any = new Reserva();
    // @Input() Orcamento: any;
    @Input() orcamento: Orcamento;
    @Input() hoteis: Hotel;
    @Input() reserva: Reserva;
    @Input() aereo: Aereo;
    @Input() pacote: Pacote;
    @Input() betoCarrero: BetoCarrero;
    @Input() carros: Carro;
    @Input() protudooffline: ProdutoOffline;
    @Input() busca: any;
    @Input() reservaPagamento: ReservaPagamento;
    @Input() circuito: Circuito;
    objeto: any;
    aereoLoadded = false;
    hotelLoadded = false;
    servicoLoadded = false;
    servicoLoadded2 = false;
    betoLoadded = false;
    pagamentoLoadded = false;
    pacoteLoadded = false;
    apiLocale = API;
    backgroundImage = BACKGROUNDIMAGE;
    Arr = Array;
    dif: number;
    usaLamina = USA_LAMINAS;
    usaCarro = USA_CARRO;
    usaPacote = USA_PACOTE;

    mensagensErroProduto: string[];
    mensagemSucessoProduto: string;

    mensagensErroCircuito: string[];
    mensagemSucessoCircuito: string;

    USA_BETO: boolean = USA_BETO;
    usaTermometro: boolean = USA_TERMOMETRO
    // fazerTraducao: any;
    paises = [
        { name: 'Brasil', ddi: '+55', code: 'BR', mask: '(00) 00000-0000' },
        { name: 'Paraguai', ddi: '+595', code: 'PY', mask: '(000) 000 000' },
        { name: 'Peru', ddi: '+51', code: 'PE', mask: '(00) 000 0000' },
        { name: 'África do Sul', ddi: '+27', code: 'ZA', mask: '00 000 0000' },
        { name: 'Alemanha', ddi: '+49', code: 'DE', mask: '000 00000000' },
        { name: 'Argentina', ddi: '+54', code: 'AR', mask: '(00) 0000-0000' },
        { name: 'Austrália', ddi: '+61', code: 'AU', mask: '0 0000 0000' },
        { name: 'Canadá', ddi: '+1', code: 'CA', mask: '(000) 000-0000' },
        { name: 'China', ddi: '+86', code: 'CN', mask: '000 0000 0000' },
        { name: 'Colômbia', ddi: '+57', code: 'CO', mask: '(000) 000 0000' },
        { name: 'Coreia do Sul', ddi: '+82', code: 'KR', mask: '00 000 0000' },
        { name: 'Espanha', ddi: '+34', code: 'ES', mask: '000 000 000' },
        { name: 'Estados Unidos', ddi: '+1', code: 'US', mask: '(000) 000-0000' },
        { name: 'França', ddi: '+33', code: 'FR', mask: '0 000 000 000' },
        { name: 'Índia', ddi: '+91', code: 'IN', mask: '0000 000 000' },
        { name: 'Itália', ddi: '+39', code: 'IT', mask: '000 000 0000' },
        { name: 'Japão', ddi: '+81', code: 'JP', mask: '000 000 0000' },
        { name: 'México', ddi: '+52', code: 'MX', mask: '(00) 0000 0000' },
        { name: 'Nova Zelândia', ddi: '+64', code: 'NZ', mask: '0 0000 0000' },
        { name: 'Portugal', ddi: '+351', code: 'PT', mask: '000 000 000' },
        { name: 'Reino Unido', ddi: '+44', code: 'UK', mask: '0000 000 000' },
        { name: 'Rússia', ddi: '+7', code: 'RU', mask: '(000) 000-0000' },
        { name: 'Suíça', ddi: '+41', code: 'CH', mask: '00 000 0000' }
    ];

    @ViewChild("pagamento") pagamentoModal: ElementRef;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        private agenciaService: AgenciaService,
        private reservaService: ReservaService,
        private loginService: LoginService,
        private usuarioService: UsuarioService,
        private voucherService: VoucherService,
        private carroService: CarroService,
        private produtoService: ProdutoOfflineService,
        private circuitoService: CircuitoService,
        private modalService: NgbModal,
        private utilService: Util,
        private ref: ChangeDetectorRef
    ) {
        this.empresa = JSON.parse(sessionStorage.getItem("loggedUser"));
        this.dataAtual = moment().format("YYYY-MM-DD");
    }
    pagamentosRealizados: ReservaPagamento[] = [];
    orcamentocliente: string = "";
    // Mensagens
    mensagemIdadeCertaVoltaViagem: string = null;
    mensagemSucessoPessoas: string = null;
    mensagensErroPessoas: string[] = null;
    mensagemSucessoHotel: string = null;
    mensagensErroHotel: string[] = null;
    mensagensSucessoPacote: string = "";
    mensagensErroPacote: string = "";
    mensagemSucessoAereo: string = null;
    mensagensErroAereo: string[] = null;
    mensagensErroReserva: string[];
    mensagemSucessoReserva: string;
    mensagensErroCarro: string[];
    mensagemSucessoCarro: string;

    // Booleans
    modalcomprovantecartao = false;
    passageirosConfirmados = false;
    IdadeCertaVoltaViagem = true;
    removeUltimoHotel = false;
    toggleConsultor = false;
    togglePessoas = false;
    auxAereoVolta = true;
    carregando = true;
    aprovaPix = false;
    auxAereoIda = true;
    perfilRoot: boolean;
    servicoCarregando: boolean;
    remove_ultimo_hotel = false;

    // Any
    alteracoesPessoas: any;
    agenteSelecionado: any;
    agenteListaRadio: any;
    chavePessoa: any;
    itemReserva: any;
    permissoes: any;
    dataAtual: any;
    Consultor: any;
    empresa: any;
    usuario: any;
    idTEMP: any;
    idTEMP2: any;
    aereos: any;
    agente: any;
    carregandoObj = false;
    spinnerAereo = false;
    spinnerServico = false;
    OfflineProdutoId: any;
    CircuitoId: any;
    fazerTraducao: any;
    SlipId: any;

    // Other
    // pacote = [];
    incluso: string;
    opcoesValores = [];
    agenteLista: [];
    agencias = [];
    agentes = [];
    perfis = [];
    erros = [];
    agenciaId: number;
    hoje = moment();
    num: Hotel;
    totalServico = 0;
    liberar_voucher = false;
    alterapaxcomreserva = false;
    podePagar = false;
    NomeAgencia = "";
    agenteNome = "";
    objModal: any;
    itemDetalhes: any;

    distinct = (value, index, self) => {
        return self.indexOf(value) === index;
    };

    console(obj) {
        console.log(obj);
    }

    // limparMensagensBeto() {
    //     delete this.mensagensErroBeto;
    //     delete this.mensagemSucessoBeto;
    // }

    ngOnInit() {
        this.busca = JSON.parse(sessionStorage.getItem("busca"));

        this.dataAtual = moment().format("YYYY-MM-DD");
        this.idTEMP = this.route.snapshot.params.id;
        if (this.idTEMP !== undefined) {
            setTimeout(() => {
                this.carregarObjeto(this.idTEMP);
            }, 500);
        }

        this.usuario = this.loginService.user();
        const permi = window.localStorage.getItem("permission");
        if (permi != null) {
            this.permissoes = JSON.parse(atob(permi));
            this.perfilRoot = this.permissoes.indexOf("root") > -1;
            this.aprovaPix =
                this.permissoes.indexOf("aprova_pix") > -1 ||
                this.permissoes.indexOf("admin") > -1 ||
                this.permissoes.indexOf("root") > -1;

            this.removeUltimoHotel =
                this.permissoes.indexOf("remove_ultimo_hotel") > -1 ||
                this.permissoes.indexOf("admin") > -1 ||
                this.permissoes.indexOf("root") > -1;

            this.liberar_voucher = this.permissoes.indexOf("liberar_voucher") > -1 ||
                this.permissoes.indexOf("admin") > -1 ||
                this.permissoes.indexOf("root") > -1;

            this.alterapaxcomreserva = this.permissoes.indexOf("alterapaxcomreserva") > -1;


        }

        // this.buscaAgentes();
        this.servicoCarregando = true;
    }

    onPaisChange(pessoa) {
        const pais = this.paises.find(c => c.code === pessoa.Pais);
        if (pais) {
            pessoa.mask = pais.mask;
        }
    }

    validaCaracterEspecial(value: string): boolean {
        const regex = /[^ \w]/;
        return regex.test(value);
    }

    consultarPagamento(pagamento) {
        this.mensagemSucessoReserva = '';
        this.reservaService.consultarPagamento(pagamento.Id).subscribe(
            dados => {
                this.atualizarOrcamento()
                switch (dados.Status) {
                    case 4:
                        this.mensagemSucessoReserva = 'Status Atual do Pagamento: APROVADO';
                        break;
                    case 2:
                        this.mensagemSucessoReserva = 'Status Atual do Pagamento: CONFIRMADO';
                        break;
                    case 3:
                        this.mensagemSucessoReserva = 'Status Atual do Pagamento: RECUSADO';
                        break;
                    case 5:
                        this.mensagemSucessoReserva = 'Status Atual do Pagamento: CANCELADO';
                        break;
                    case 6:
                        this.mensagemSucessoReserva = 'Status Atual do Pagamento: ESTORNADO';
                        break;
                    case 0:
                        this.mensagemSucessoReserva = 'Status Atual do Pagamento: PENDENTE';
                        break;
                }
            }, erro => {
                this.mensagensErroReserva.push(this.utilService.errorHandler(erro));
            })
    }

    abrirModalLaminas(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: "modal-grande", backdrop: 'static' });
    }

    abrirLinkPagamento(pagamento) {
        this.reservaService.gerarLinkPagamento(pagamento.Id).subscribe(
            dados => {
            },
            error => {
                console.log(error);
            });
    }

    ngAfterViewInit() {
        this.servicoCarregando = false;
    }

    buscarOrcamento() {
        this.idTEMP = this.route.snapshot.params.id;
        this.reservaService.buscarOrcamento(this.idTEMP).subscribe(
            (dados) => {
                this.reserva = dados;

                setTimeout(() => {
                    this.buscaAgentes(true);
                }, 100);
            },
            (erro) => console.log(erro)
        );
    }

    buscaAgentes(primeira = false) {
        // const agencia = JSON.parse(localStorage.getItem("loggedUser"));
        //
        // if (agencia.agenciaId == (null || undefined)) {
        //   const agencia = atob(localStorage.getItem("g8h7d8"));
        //   const agenciaId = JSON.parse(agencia);
        //   this.idTEMP2 = agenciaId.Id;
        // } else {
        //   this.idTEMP2 = agencia.AgenciaId;
        // }

        this.usuarioService
            .buscarPorAgencia(this.agenteNome, 1, this.Orcamento.AgenciaId)
            .subscribe(
                (dados) => {
                    this.agentes = dados.Items;

                    if (primeira) {
                        let i = this.agentes
                            .map((x) => x.Id)
                            .indexOf(this.Orcamento.AgenteId);
                        this.Orcamento.Agente = this.agentes[i];
                    }
                },
                (erros) => {
                    console.log("Erro ao buscar usuarios da agencia: ", erros);
                    this.agentes = [];
                }
            );
    }

    onChangeAgencia(val) {
        this.agenciaService.buscarPorParametro(val, 1).subscribe(
            (dados) => {
                this.agencias = dados.Items.map(function (x) {
                    x.display_field = x.NomeFantasia;
                    return x;
                });
            },
            (erro) => {
                console.log(erro);
                this.agencias = [];
            }
        );
    }

    selecionaAgencia(agencia) {
        let primeira = false;
        if (this.Orcamento.AgenciaId != agencia.Id) {
            this.Orcamento.Agente = null;
            this.Orcamento.AgenteId = 0;
            primeira = true;
        }

        this.Orcamento.Agencia = agencia;
        this.Orcamento.AgenciaId = agencia.Id;
        this.buscaAgentes(primeira);
    }

    carregarObjeto(id) {
        this.reservaService.buscarOrcamento(id).subscribe(
            (dados) => {
                this.Orcamento = dados;
                this.agenciaId = this.Orcamento.AgenciaId;
                this.pacote = this.Orcamento.Hoteis.filter((x) => x.PacoteId != null);

                this.Orcamento.Pessoas = this.Orcamento.Pessoas.map((x) => {
                    if (!x.Pais) {
                        x.Pais = 'BR';
                    }
                    this.onPaisChange(x);
                    x.Nascimento = x.Nascimento
                        ? moment(x.Nascimento).format("DDMMYYYY")
                        : null;
                    return x;
                });

                this.Orcamento.Quartos = this.Orcamento.Pessoas.map(x => x.Quarto).filter(this.distinct).sort();

                this.Orcamento.Quartos = this.Orcamento.Quartos.map(x => {
                    return { quarto: x, pessoas: this.Orcamento.Pessoas.filter(y => y.Quarto === x) };
                });

                if (this.Orcamento.Hoteis && this.Orcamento.Hoteis.length > 0) {
                    this.Orcamento.Hoteis = this.Orcamento.Hoteis.sort(function (a, b) {
                        return a.Opcao - b.Opcao;
                    });

                    this.Orcamento.Hoteis = this.Orcamento.Hoteis.map(x => {
                        x.Quartos = x.Quartos.sort(function (a, b) {
                            return a.Pesquisa - b.Pesquisa;
                        });
                        return x;
                    });
                }

                this.Orcamento.Servicos = this.Orcamento.Servicos.map(x => {
                    if (this.isJson(x.ExtraIntegracao)) {
                        x.ExtraIntegracao2 = JSON.parse(x.ExtraIntegracao);
                    }
                    return x;
                });

                if (this.Orcamento.OfflineProdutos || this.Orcamento.OfflineProdutos.length > 0) {
                    this.Orcamento.Brindes = this.Orcamento.OfflineProdutos.filter(x => x.OfflineProdutoTipo.Sigla == "BR");
                    this.Orcamento.OfflineProdutos = this.Orcamento.OfflineProdutos.filter(x => x.OfflineProdutoTipo.Sigla != "BR");
                }
                // if (this.Orcamento.Consultor == null) {
                //     this.abrirModalConsultor(this.contentSelecionarConsultor);
                // } else {
                //     if (this.Orcamento.Agente == null) {
                //         this.abrirModalAgente(this.contentSelecionarAgente);
                //     }
                // }

                if (this.Orcamento.PacoteReservas && this.Orcamento.PacoteReservas.length > 0) {
                    this.Orcamento.PacoteReservas.forEach(x => {
                        x.Tarifa = x.Pacote.PacoteTarifas.find(y => y.Id == x.CodigoTarifa);
                    });
                }
                this.orcamentocliente = this.Orcamento?.Servicos[0]?.CodigoCliente?.split('-')[0];
                this.aereos = this.Orcamento.Aereos;
                this.hoteis = this.Orcamento.Hoteis;
                this.servicos = this.Orcamento.Servicos;
                this.carros = this.Orcamento.Carros;
                this.betoCarrero = this.Orcamento.betoCarrero;
                this.circuito = this.Orcamento.Circuito;
                this.pagamentosRealizados = this.Orcamento.Pagamentos;
                this.togglePessoas = !this.paxValido();

                this.valoresOpcoes();
                this.verificaIncluso();
                this.IdadeCertaVoltaViagem = this.Orcamento.Pessoas.every(
                    (x) => x.IdadeCertaVoltaViagem === true
                );
                if (!this.IdadeCertaVoltaViagem) {
                    this.mensagemIdadeCertaVoltaViagem = `
                    <h5>Atenção:</h5>
                    <p>
                    Para que o sistema calcule corretamente o orçamento, é necessário informar uma data de nascimento compatível com a idade inserida na pesquisa.
                    Importante levar em consideração a idade dos passageiros ao término da viagem, ou seja, caso algum passageiro faça aniversário durante a viagem,
                    informe a idade que ele terá no dia do retorno. Essa informação é indispensável para cálculo de tarifa aérea,
                    INF/CHD/ADT e também para políticas de CHD/ADT em hotéis, serviços de receptivo e seguro viagem.
                    </p>`;
                }

                this.buscaAgentes();

                this.carregando = false;
                this.verificaConsultor();
                // this.verificarPodePagar(id);
            },
            (erro) => {
                console.log("Erro ao buscar o objeto da reserva");
                console.log(erro);
                this.mensagensErroReserva.push(this.utilService.errorHandler(erro));
            }
        );
    }

    removerProdutoOffline(produtooffline) {
        if (confirm("Confirmar exclusão do produto?")) {

            if (this.validaTermometro()) {
                alert(this.fazerTraducao("Necessário retornar o valor do termômetro para padrão antes de remover esse item."))
                return;
            }

            this.produtoService.removerProduto(produtooffline.Id).subscribe(
                dados => {
                    this.limparMensagensProduto();
                    this.mensagemSucessoReserva = `Produto Offline ${dados.Id} removido com sucesso!`;
                    this.atualizarOrcamento();
                    // this.ValoresOpcoes();
                },
                erro => {
                    this.mensagensErroReserva.push(this.utilService.errorHandler(erro));
                });
        }
    }

    atualizarProduto(produtooffline) {
        const i = this.Orcamento.ProdutoOffline.map((x) => x.Id).indexOf(produtooffline.Id);
        this.Orcamento.ProdutoOffline[i] = produtooffline;
    }

    verificarPodePagar(id) {
        this.reservaService.verificarPodePagar(id).subscribe(
            () => {
                this.podePagar = true;
            },
            erro => {
                this.podePagar = false;
            });
    }

    public confirmarLiberar() {
        this.mensagensErroReserva = null;
        this.mensagemSucessoReserva = '';

        const resposta = window.confirm(
            'Tem certeza que deseja liberar os vouchers para a reserva ?'
        );

        if (resposta) {
            this.LiberarVoucher();
        }
    }


    LiberarVoucher() {
        this.reservaService.LiberarVoucher(this.Orcamento.Id).subscribe(
            dados => {
                this.mensagemSucessoReserva = 'Os vouchers da reserva foram liberados com sucesso !';

                this.Orcamento.LiberarVoucher = true;
            },
            erro => {
                console.log('Erro ao Liberar');
                console.log(erro);
                this.mensagensErroReserva.push(this.utilService.errorHandler(erro));
            },
        );
    }

    verificaConsultor() {
        this.Consultor = this.Orcamento.Consultor === null || this.Orcamento.Consultor === undefined ? false : true;
    }

    paxValido() {
        return this.Orcamento.Pessoas.filter(
            pax => (
                !pax.Nome ||
                !pax.Sobrenome ||
                !pax.Nascimento ||
                (!pax.Email && this.Orcamento.Aereos.length > 0) ||
                (!pax.Telefone && this.Orcamento.Aereos.length > 0) ||
                !this.validaData(pax.Nascimento) ||
                !pax.Sexo)
        ).length == 0;
    }

    estornar(pagamento, index) {
        const resposta = window.confirm(`Tem certeza que deseja estornar o pagamento ?`);

        if (resposta) {
            this.reservaService.estornarPagamento(pagamento.Id).subscribe(
                dados => {
                    alert(`Pagamento ${dados.StatusDesc}!`);
                    this.atualizarOrcamento();
                }, erro => {
                    alert(erro.error.mensagem);
                });
        }
    }

    validaCPF(input, nacionalidade) {
        if (nacionalidade == "BR") {
            return cpf.isValid(input);
        }
        else {
            return true;
        }
    }

    validaData(data) {
        // tirar formatacao da data
        if (//data formatada
            data.length == 10 &&
            (data.indexOf("/") > -1 || data.indexOf("-") > -1)
        ) {
            data = data.replace(/\//g, "");
            data = data.replace(/-/g, "");
        }

        data = moment(data, "DDMMYYYY", true);
        const now = moment();
        return data && data.isValid() && data < now;
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    valoresOpcoes() {
        this.opcoesValores = [];
        //console.log(this.Orcamento);
        const totalAereo = this.Orcamento.Aereos.map((x) => x.ValorFechamento).reduce(
            function (a, b) {
                return a + b;
            },
            0
        );
        const totalServico = this.Orcamento.Servicos.map(
            (x) => x.ValorFechamento
        ).reduce(function (a, b) {
            return a + b;
        }, 0);

        const totalBeto = this.Orcamento.BetoCarreroIngressos.map(
            (x) => x.ValorFechamento
        ).reduce(function (a, b) {
            return a + b;
        }, 0);
        let total = totalAereo + totalServico + totalBeto;
        let opcoes = this.Orcamento.Hoteis.map((x) => x.Opcao);
        opcoes = Array.from(new Set(opcoes));
        opcoes.forEach((element) => {
            const hoteis = this.Orcamento.Hoteis.filter(
                (x) =>
                    x.Opcao === element &&
                    x.Status !== 8 &&
                    x.Status !== 7 &&
                    x.Status !== 10
            );
            const totalHotel = hoteis
                .map((x) => x.ValorVendaMoedaDestino)
                .reduce(function (a, b) {
                    return a + b;
                }, 0);
            const dadoshoteis = hoteis.map((x) => {
                x.CheckinOpcao = moment(x.Checkin).format("DD/MM/YYYY");
                x.CheckoutOpcao = moment(x.Checkout).format("DD/MM/YYYY");
                return x;
            });
            const totalPacote = hoteis
                .map((x) => x.ValorPacote)
                .reduce(function (a, b) {
                    return a + b;
                }, 0);
            let totalOpcao = total + totalHotel + totalPacote;

            if (this.Orcamento.ValorDescontoComissao) {
                totalOpcao += this.Orcamento.ValorDescontoComissao;
            }
            if (this.Orcamento.ValorOver) {
                totalOpcao += this.Orcamento.ValorOver;
            }

            this.opcoesValores.push({
                opcao: element,
                valor: totalOpcao,
                dados: dadoshoteis,
            });

            //console.log(this.opcoesValores);

            this.opcoesValores.sort(function (a, b) {
                const result = a.opcao - b.opcao;
                // console.log("AQUI: ", result);
                return result;
            });
        });

        if (this.opcoesValores.length == 0) {

            if (this.Orcamento.ValorDescontoComissao) {
                total += this.Orcamento.ValorDescontoComissao;
            }
            if (this.Orcamento.ValorOver) {
                total += this.Orcamento.ValorOver;
            }
            this.opcoesValores.push({ opcao: 1, valor: total, dados: [] })
        }
    }

    verificaIncluso() {
        this.incluso = "";
        if (this.Orcamento.Aereos.length > 0) {
            this.incluso = "Aéreo";
        }

        if (this.Orcamento.Servicos.length > 0) {
            if (this.incluso !== "") {
                this.incluso += " + ";
            }
            this.incluso += "Serviço";
        }

        if (this.Orcamento.Seguros.length > 0) {
            if (this.incluso !== "") {
                this.incluso += " + ";
            }
            this.incluso += "Seguro";
        }
        if (this.Orcamento.BetoCarreroIngressos.length > 0) {
            if (this.incluso !== "") {
                this.incluso += " + ";
            }
            this.incluso += "Beto Carrero";
        }
    }

    orcamentoOpcoesCompleto() {
        let endereco = `${window.location.origin}/#/orcamentodownload/false/${this.Orcamento.Id}`;
        // window.open(this.reservaService.urlOrcamento(), "_blank");
        window.open(endereco, "_blank");
    }

    orcamentoOpcoesSimplificado() {
        let endereco = `${window.location.origin}/#/orcamentodownload/true/${this.Orcamento.Id}`;
        //console.log("endereco", endereco)
        // window.open(this.reservaService.urlOrcamento(), "_blank");
        window.open(endereco, "_blank");
    }

    changeAgente(e) {
        this.agenteListaRadio = e.target.value;
        console.log("Change Agente: ", this.agenteListaRadio);
    }

    mudarAgente() {
        this.reservaService
            .AlterarAgenteReserva(this.idTEMP, this.agenteListaRadio)
            .subscribe(
                (dados) => {
                    this.agenteLista = dados;
                    this.agenteSelecionado =
                        this.agente.Nome + " " + this.agente.Sobrenome;
                    window.location.reload();
                },
                (erro) => console.log(erro)
            );
    }

    atualizarOrcamento() {
        this.carregarObjeto(this.Orcamento.Id);
    }

    abrirModalCancelarCircuito(content, item) {
        this.itemReserva = item;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', centered: true, size: 'lg' });
    }

    abrirModalProdutoOffline(content, id = null) {
        this.OfflineProdutoId = id;
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    atualizarOfflineProduto(offlineproduto) {
        let i = this.Orcamento.OfflineProdutos.map(x => x.Id).indexOf(offlineproduto.Id);
        this.Orcamento.OfflineProdutos[i] = offlineproduto;

        this.atualizarOrcamento();
    }

    idadeInvalida: boolean = true;
    idadeErrada() {
        let erroNaIdade = false;

        this.Orcamento.Pessoas.forEach(x => {

            // Validação do e-mail
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (x.Email && !emailRegex.test(x.Email)) {
                console.error(`Email inválido: ${x.Email}`);
                alert(`Email inválido: ${x.Email}`);
                erroNaIdade = true;
            }

            if (x.Nascimento) {
                const nascimento = moment(x.Nascimento, 'DDMMYYYY');
                const idade = moment().diff(nascimento, 'years');
                if (x.Tipo != 0) {
                    if (Math.abs(idade - x.Idade) > 1) {
                        if (x.Tipo == 1)
                            alert(`A Criança tem ${idade} anos, o que difere da idade selecionada na busca ${x.Idade} anos.`);
                        if (x.Tipo == 2)
                            alert(`O Bebê tem ${idade} anos, o que difere da idade selecionada na busca ${x.Idade} anos.`);
                        erroNaIdade = true;
                    }
                }
            } else {
                erroNaIdade = true;

            }
        });

        if (erroNaIdade)
            alert(`Data de nascimento invalida para 1 ou mais passageiros`);
        this.idadeInvalida = erroNaIdade;
        this.ref.detectChanges();
        // return erroNaIdade;
    }

    salvarDadosPessoas() {
        this.limparMensagensPessoas();

        // if (this.idadeErrada())
        //     return;

        this.Orcamento.Pessoas = this.Orcamento.Pessoas.map((x) => {
            x.Nascimento = moment(x.Nascimento, 'DDMMYYYY');
            x.Nome = x.Nome.trim();
            x.Sobrenome = x.Sobrenome.trim();
            x.Email = x.Email ? x.Email.trim() : null;
            return x;
        });

        this.reservaService.salvarDadosPessoas(this.Orcamento.Pessoas).subscribe(
            (dados) => {
                this.Orcamento.Pessoas = dados;

                this.Orcamento.Pessoas = this.Orcamento.Pessoas.map((x) => {

                    x.Nascimento = x.Nascimento
                        ? moment(x.Nascimento).format("DDMMYYYY")
                        : null;
                    x.Nome = x.Nome.trim();
                    x.Sobrenome = x.Sobrenome.trim();
                    x.Email = x.Email ? x.Email.trim() : null;
                    this.onPaisChange(x);
                    return x;
                });
                this.Orcamento.Quartos = this.Orcamento.Pessoas.map((x) => x.Quarto)
                    .filter(this.distinct)
                    .sort();
                this.Orcamento.Quartos = this.Orcamento.Quartos.map((x) => {
                    return {
                        quarto: x,
                        pessoas: this.Orcamento.Pessoas.filter((y) => y.Quarto === x),
                    };
                });
                this.IdadeCertaVoltaViagem = dados.every(
                    (x) => x.IdadeCertaVoltaViagem === true
                );
                if (!this.IdadeCertaVoltaViagem) {
                    this.mensagemIdadeCertaVoltaViagem = `<h5>Atenção:</h5>
          <p>
          Para que o sistema calcule corretamente o orçamento, é necessário informar uma data de nascimento compatível com a idade inserida na pesquisa.
          Importante levar em consideração a idade dos passageiros ao término da viagem, ou seja, caso algum passageiro faça aniversário durante a viagem,
          informe a idade que ele terá no dia do retorno. Essa informação é indispensável para cálculo de tarifa aérea,
          INF/CHD/ADT e também para políticas de CHD/ADT em hotéis, serviços de receptivo e seguro viagem.
          </p>`;
                }
                this.mensagemSucessoPessoas = "Dados atualizados com sucesso!";
            },
            (erro) => {
                console.log("Erro ao salvar pessoas!");
                console.log(erro);
                this.mensagensErroPessoas.push(this.utilService.errorHandler(erro));
            }
        );

        alert("PAX confirmados/editados");
    }

    limparMensagensPessoas() {
        delete this.mensagemSucessoPessoas;
        delete this.mensagensErroPessoas;
        delete this.mensagemIdadeCertaVoltaViagem;
    }

    carregar(obj, tipo) {
        this.objeto = obj;

        switch (tipo) {
            case "pagamento":
                this.pagamentoLoadded = true;
                setTimeout(() => {
                    this.pagamentoModal.nativeElement.click();
                }, 100);
                break;
        }
    }

    getStatus(status) {
        switch (status) {
            case 0:
                return "PENDENTE";
            case 1:
                return "AGUARDANDOINTEGRADOR";
            case 2:
                return "PARCIALMENTECONFIRMADO";
            case 3:
                return "RESERVADO";
            case 4:
                return "CONFIRMADO";
            case 7:
                return "PROBLEMATECNICO";
            case 8:
                return "CANCELADA";
        }
    }

    selecionaConsultor(consultor) {
        if (
            this.Orcamento.Consultor != null &&
            consultor.Id === this.Orcamento.Consultor.Id
        ) {
            // return true;
        }

        this.reservaService
            .alterarConsultor(this.Orcamento.Id, consultor.Id)
            .subscribe(
                (dados) => {
                    this.Consultor = consultor;
                    this.Orcamento.Consultor = consultor;
                    this.mensagemSucessoReserva = "Consultor alterado com sucesso";
                },
                (erro) => {
                    console.log(erro);
                    this.mensagensErroReserva.push(this.utilService.errorHandler(erro));
                    alert("Erro ao selecionar consultor");
                }
            );
    }

    alternaAuxAereoIda() {
        this.auxAereoIda = !this.auxAereoIda;
    }

    alternaAuxAereoVolta() {
        this.auxAereoVolta = !this.auxAereoVolta;
    }

    somaServico(x, i: any) {
        if (x == 0) {
            this.totalServico = i;
        } else {
            this.totalServico = +this.totalServico + i;
        }
    }

    atualizarPagamentos(pagamentos) {
        this.carregarObjeto(this.Orcamento.Id);
    }

    adicionarItem(event, item, itemObjeto = null) {
        let busca: Busca;
        busca = new Busca();

        busca.tipoBusca.aereo = false;
        busca.tipoBusca.hotel = false;
        busca.tipoBusca.transfer = false;
        busca.tipoBusca.ticket = false;
        busca.tipoBusca.carro = false;
        busca.tipoBusca.seguro = false;
        busca.tipoBusca.beto = false;
        busca.tipoBusca.produtooffline = false;
        busca.tipoBusca.circuito = false;

        switch (item) {
            case 'aereo':
                busca.tipoBusca.aereo = true;
                break;
            case 'hotel':
                if (itemObjeto) {
                    busca.trechos[0].dataIda = itemObjeto.Checkin;
                    busca.trechos[0].dataVolta = itemObjeto.Checkout;
                }
                this.modalService.dismissAll();
                busca.tipoBusca.hotel = true;
                break;
            case 'transfer':
            case 'servico':
            case 'ticket':
                busca.tipoBusca.ticket = true;
                break;
            case 'carro':
                busca.tipoBusca.carro = true;
                break;
            case 'seguro':
                busca.tipoBusca.seguro = true;
                break;
            case 'beto':
                busca.tipoBusca.beto = true;
                break;
            case 'produtooffline':
                busca.tipoBusca.produtooffline = true;
                break;
            case 'servicoExclusivo':
                busca.tipoBusca.servicoExclusivo = true;
                break;
            case 'circuito':
                busca.tipoBusca.circuito = true;
                break;
        }

        busca.ReservaId = this.Orcamento.Id;
        busca.usuario = this.loginService.user();
        window.sessionStorage.removeItem('busca');
        window.sessionStorage.setItem('busca', JSON.stringify(busca));

        const dataParaCancelarBusca = addOrSubtractDays(new Date(), { minute: 10 });
        window.sessionStorage.setItem("timerBusca", dataParaCancelarBusca.toISO());
        //  }

        window.localStorage.setItem('g8h7d8', btoa(JSON.stringify(this.Orcamento.Agencia)));
        if (!busca.tipoBusca.beto) {
            this.router.navigate([`busca/${this.Orcamento.Id}`]);
        } else {
            this.router.navigate([`beto-carrero/${this.Orcamento.Id}`]);
        }
    }

    hoteisEDatas: { Nome: string, Checkin: string, Checkout: string }[] = []
    levaDataHotelProBuscador(modal) {
        this.hoteisEDatas = [];

        this.Orcamento.Hoteis.forEach(hotel => {
            this.hoteisEDatas.push({ Nome: hotel.Nome, Checkin: hotel.Checkin, Checkout: hotel.Checkout });
        });

        this.modalService.open(modal, { centered: true, size: 'lg' });
    }

    setDataNascimento(pessoa) {
        const novaIdade = this.getIdade(pessoa.Nascimento);
        if (pessoa.Tipo == 0) {
            pessoa.Idade = novaIdade;
        }
    }

    getIdade(nascimento): number {
        const datanasc = moment(nascimento, "DD/MM/YYYY");
        const timeDiff = Math.abs(Date.now() - datanasc.valueOf());
        const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
        return age;
    }

    imprimirVoucher(tipo, item) {
        if (tipo === "beto") {
            window.open(item.UrlImpressaoPDF, "_blank");
            return;
        }

        if (!item.VoucherKey) {
            let endereco = `${window.location.origin}/voucher/`;
            this.voucherService.gerarVoucher(tipo, item, endereco)
                .subscribe(
                    dados => {
                        item.VoucherKey = dados;
                        this.exibeVoucher(item.VoucherKey);
                    },
                    error => {
                        switch (item) {
                            case 'aereo': this.mensagensErroAereo.push(this.utilService.errorHandler(error)); break;
                            case 'hotel': this.mensagensErroHotel.push(this.utilService.errorHandler(error)); break;
                            case 'pacote': this.mensagensErroPacote = this.utilService.errorHandler(error)[0]; break;
                            //case 'seguro': this.mensagensErroSeguro = this.errorHandler(error); break;
                            default: this.utilService.errorHandler(error); break;

                        }
                    });
        } else
            return this.exibeVoucher(item.VoucherKey);

    }

    exibeVoucher(VoucherKey) {
        window.open(`/#/voucher/${VoucherKey}`, "_blank");
    }

    confirmarRemoverCarro(carro) {
        const resposta = window.confirm(`Tem certeza que deseja excluir o carro: ${carro.Descricao} ?`)

        if (resposta) {
            this.removerCarro(carro);
        }
    }

    removerCarro(carro) {
        if (this.validaTermometro()) {
            alert(this.fazerTraducao("Necessário retornar o valor do termômetro para padrão antes de remover esse item."));
            return;
        }

        this.carroService.removerCarro(carro).subscribe(
            dados => {

                this.Orcamento.Carros = this.Orcamento.Carros.filter(x => x.Id !== dados.Id);
                this.mensagemSucessoCarro = `Carro ${dados.Id} removido com sucesso!`;
                this.atualizarOrcamento();
            },
            erro => {
                this.mensagensErroAereo.push(this.utilService.errorHandler(erro));
            });
    }

    atualizarCarro(carro) {
        const i = this.Orcamento.Carros.map((x) => x.Id).indexOf(carro.Id);
        this.Orcamento.Carros[i] = carro;
        this.atualizarOrcamento();
    }

    limparMensagensProduto() {
        this.mensagemSucessoProduto = '';
        this.mensagensErroProduto = [];
    }

    fecharModal() {
        this.modalService.dismissAll();
    }

    statusContrato(pagamentoId: number) {
        return this.Orcamento.Contratos.filter(x => x.ReservaPagamentoId == pagamentoId).map(x => x.Status);
    }
    contratoAssinado(pagamentoId: number) {
        return this.Orcamento.Contratos
            .filter(x => x.ReservaPagamentoId == pagamentoId)
            .map(x => x.Assinaturas).flat()
            .filter(y => y.TipoPessoaAssinatrua == 0 && (y.AssinaturaDigitalizada != null && y.AssinaturaDigitalizada.length > 0)).length > 0;
    }
    temPagamentoComTipo4(): boolean {
        return this.pagamentosRealizados.some(pgto => pgto.TipoPagamento == 4);
    }

    GeraChaveLinkPDF(pagamentoId: number) {
        this.reservaService.geradorChaveLinkPDF(pagamentoId).subscribe(
            dados => {
                window.open(dados);
            },
            error => {
                this.mensagensErroReserva.push(this.utilService.errorHandler(error));
                alert(error.error.mensagem);
            }
        )
    }
    confirmarNovoLink(id) {
        this.mensagensErroReserva = null;
        this.mensagemSucessoReserva = '';
        const confirmar = window.confirm('Acessar Contrato e gerar nova assinatura. Deseja descartar Assinatura atual e gerar uma nova?');
        if (confirmar) {
            this.GeraChaveLink(id);
        }
    }
    public confirmarGeraChave(id) {
        this.mensagensErroReserva = null;
        this.mensagemSucessoReserva = '';
        const confirmar = window.confirm('Descartar assinatura atual caso tenha e gerar uma nova?');
        if (confirmar) {
            this.GeraChave(id);
        }
    }
    validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }
    acessarBoleto(pgto) {
        this.mensagensErroReserva = null;
        const confirmar = window.confirm('ATENÇÃO: reconfirme se o valor e vencimento dos boletos foram solicitados corretamente antes de emiti-los, pois após o boleto gerado será cobrado uma taxa de cancelamento de R$ 22.00 por boleto.');
        if (pgto.Boletos && pgto.Boletos.length == 1) {
            if (confirmar && this.validURL(pgto.Boletos[0].URL)) {
                window.open(pgto.Boletos[0].URL);
            }
        }
        else if (pgto.TipoPagamento == 4 && this.validURL(pgto.Financiamentos[0].Link)) {
            if (confirmar) {
                window.open(pgto.Financiamentos[0].Link);
            }
        }
        else {
            this.mensagensErroReserva.push('Boleto indisponível, entre em contato com seu consultor');
        }
    }

    GeraChaveLink(pagamentoId: number) {
        this.reservaService.geradorChaveLink(pagamentoId).subscribe(
            dados => {
                // console.log(dados);
                window.open(dados);
            },
            error => {
                console.log(error);
                this.mensagensErroReserva.push(this.utilService.errorHandler(error));
                alert(error.error.mensagem)
            }
        )
    }
    GeraChave(pagamentoId: number) {
        this.reservaService.geradorChave(pagamentoId).subscribe(
            dados => {
                alert('Chave enviada por email!');
            },
            error => {
                console.log(error);
                this.mensagensErroReserva.push(this.utilService.errorHandler(error));
                alert(error.error.mensagem);
            }
        )
    }
    acessarFinanciamento(pgto) {
        this.router.navigate([`/financiamento/${pgto.Financiamentos[0].Id}`]);
        console.log(pgto.Financiamentos[0].Id);
    }

    abrirModalTermometro(content, item) {
        this.itemReserva = item;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', centered: true, size: 'lg' });
    }

    atualizarTermometro(event) {
        this.carregarObjeto(this.Orcamento.Id);
    }

    validaTermometro() {
        return (this.Orcamento.ValorDescontoComissao < 0 || this.Orcamento.ValorOver > 0);
    }

    abrirModalSlip(content, id = null) {
        this.SlipId = id;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', centered: true, size: 'lg' });
    }

    atualizarCampoGenericoOrcamento(nomeLista: string, idItem: number) {
        this.Orcamento[nomeLista] = this.Orcamento[nomeLista].filter(x => x.Id !== idItem);
    }

    dataLista: any[] = [];
    buscaPessoas(pesquisa: string = "", indiceQuarto: number = null, indicePessoa: number = null, tipoBusca: string = "CPF") {
        this.reservaService.buscaReservaPorPesquisa(pesquisa).subscribe(
            (dados) => {
                if (tipoBusca === "CPF"){
                    this.selecionaPessoa(dados, indiceQuarto, indicePessoa);
                } else {
                    this.dataLista = dados.map((x) => {
                        return {
                            Nome: x.Nome,
                            Sobrenome: x.Sobrenome,
                            Nascimento: moment(x.Nascimento),
                            Email: x.Email,
                            Telefone: x.Telefone,
                            Passaporte: x.Passaporte,
                            CPF: x.CPF,
                            Sexo: x.Sexo,
                            Pais: x.Pais,
                            display_field: `${x.Nome} ${x.Sobrenome} - ${moment(x.Nascimento).format("DD/MM/YYYY")}`,
                        };
                    });
                }
            },
            (erro) => {
                console.log("Erro ao buscar reserva por CPF: ", erro);
                this.mensagensErroReserva.push(this.utilService.errorHandler(erro));
                alert("Erro ao buscar reserva por CPF: " + erro.error.mensagem);
            }
        )
    }

    selecionaPessoa(pessoa: any, indiceQuarto: number, indicePessoa: number) {
        const pessoaAtualizada = this.Orcamento.Quartos[indiceQuarto].pessoas[indicePessoa];

        // Atualiza as propriedades específicas da pessoa
        pessoaAtualizada.Nome = pessoa.Nome;
        pessoaAtualizada.Sobrenome = pessoa.Sobrenome;
        pessoaAtualizada.Nascimento = moment(pessoa.Nascimento).format("DD/MM/YYYY");
        pessoaAtualizada.Email = pessoa.Email;
        pessoaAtualizada.Telefone = pessoa.Telefone;
        pessoaAtualizada.Passaporte = pessoa.Passaporte;
        pessoaAtualizada.CPF = pessoa.CPF;
        pessoaAtualizada.Sexo = pessoa.Sexo;
        pessoaAtualizada.Pais = pessoa.Pais;
    }

    limparMensagensCircuito() {
        delete this.mensagensErroCircuito;
        delete this.mensagemSucessoCircuito;
    }

    paxCircuito() {
        return this.Orcamento.Pessoas.filter(
            pax => (
                !pax.Nome ||
                !pax.Sobrenome ||
                !((pax.Nome.length + pax.Sobrenome.length) > 5) ||
                // !(pax.Pais.length > 5) ||
                // !pax.Passaporte && !(pax.Passaporte.length > 5) ||
                !pax.Nascimento ||
                !this.validaData(pax.Nascimento) ||
                !pax.Sexo ||
                // ((this.Orcamento.Aereos.length > 0 && (!pax.CPF || (pax.CPF.length == 0))) || pax.CPF && !this.validaCPF(pax.CPF, pax.Pais)) ||
                pax.Sexo === 'N')
        ).length == 0;
    }

    abrirModalCircuitoReserva(content, item) {
        if (this.paxCircuito()) {
            this.itemReserva = item;
            this.modalService.open(content, { backdrop: 'static', centered: true, size: 'xl' });
        } else {
            alert("Verifique os dados dos Pax, é necessário preencher tudo pra reservar Circuito!");
        }
    }

    atualizarcircuito(Circuito) {
        this.Orcamento.Circuitos.pop()
        this.Orcamento.Circuitos.push(Circuito);
        this.atualizarOrcamento();
    }

    removerCircuito(circuito) {
        if (confirm("Confirmar exclusão do circuito?")) {
            if (this.validaTermometro()) {
                alert("Necessário retornar o valor do termômetro para padrão antes de remover esse item.");
                return;
            }

            this.circuitoService.removerCircuito(circuito.Id).subscribe(
                dados => {
                    this.limparMensagensCircuito();
                    this.mensagemSucessoReserva = `Circuito ${dados.Id} removido com sucesso!`;
                    this.atualizarOrcamento();
                },
                erro => {
                    this.mensagensErroReserva.push(this.utilService.errorHandler(erro));
                });
        }
    }

    modalDetalhes(content, item) {
        this.itemDetalhes = item;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'xl' });
    }
}
